import { all, put, SagaIterator, select } from './sagaEffects';
import { getRequestType, RefreshTokenRequest } from 'acscp/api/requests';
import { FetchRequest } from 'acscp/actions';
import { authStateSelector, requestsNotInProgress } from './selectors';
import { AuthState } from 'acscp/store';

const refreshTokenRequestNotRunningSelector = requestsNotInProgress([getRequestType(RefreshTokenRequest)]);

export function* refreshLoginTokenIfNecessary(): SagaIterator {

    const [auth, refreshNotRunning] = (yield all([
        select(authStateSelector),
        select(refreshTokenRequestNotRunningSelector)
    ])) as unknown as [AuthState, boolean, string | undefined];

    if (refreshNotRunning && !auth.token && auth.username && auth.refreshToken) {
        yield put(new FetchRequest(new RefreshTokenRequest(auth.username, auth.refreshToken)));
    }
}
